import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IState, Item } from "../../../../interfaces/interfaces";
import SectionItems from "../../../../components/SectionItems/SectionItems";
import API from "../../../../api/api";
import { addBookmarked } from "../../../../store/actions/ItemActions";
import {
  ECategory,
  EItemActionType,
  EParams,
} from "../../../../interfaces/enum";
import { useSearchParams } from "react-router-dom";

const Bookmarked = () => {
  const [params] = useSearchParams({});
  const q = params.get(EParams.QUERY);
  const { bookmarked, calledSaved } = useSelector(
    (state: IState) => state.item
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (calledSaved) return;
    API.getBookmarked().then((res) => {
      setTimeout(() => {
        dispatch(addBookmarked(res as Item[]));
        dispatch({ type: EItemActionType.CALLED_SAVED, data: true });
      }, Math.random() * 1500 + 500);
    });
  }, [dispatch, calledSaved]);

  return (
    <div className="w-100">
      <SectionItems
        items={bookmarked.filter((item) => item.category === ECategory.MOVIE)}
        title={"Bookmarked Movies"}
        isTrending={false}
        loading={!calledSaved}
      />
      {!q && (
        <>
          <div className="mt-4"></div>
          <SectionItems
            items={bookmarked.filter(
              (item) => item.category === ECategory.TV_SERIES
            )}
            title={"Bookmarked Series"}
            isTrending={false}
            loading={!calledSaved}
          />
        </>
      )}
    </div>
  );
};

export default Bookmarked;
